import React, { ReactNode, ReactElement } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons';
import { LoginSignupView } from '../constants';

import './styles.scss';

const TabButton = React.memo(
  ({
    label,
    selected,
    onClick,
  }: {
    label: string | ReactNode;
    selected?: boolean;
    onClick: () => void;
  }): ReactElement => (
    <div className="login-signup-tab-button">
      <button
        type="button"
        className={classNames({ selected })}
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  )
);

export const TabList = React.memo(
  ({
    view,
    onSelectSignup,
    onSelectLogin,
  }: {
    view: LoginSignupView;
    onSelectSignup: () => void;
    onSelectLogin: () => void;
  }): ReactElement => (
    <div className="login-signup-tab-list">
      <TabButton
        label="Sign up"
        selected={view === 'signup'}
        onClick={onSelectSignup}
      />
      <TabButton
        label="Log in"
        selected={view === 'login'}
        onClick={onSelectLogin}
      />
    </div>
  )
);

export const BackToLoginTab = React.memo(
  ({
    onBackToLoginClick,
  }: {
    onBackToLoginClick: () => void;
  }): ReactElement => (
    <div className="login-signup-tab-list">
      <button
        type="button"
        onClick={onBackToLoginClick}
        className="back-to-login-btn"
      >
        <FontAwesomeIcon icon={faArrowCircleLeft} /> Back
      </button>
    </div>
  )
);

export const TabPane = React.memo(
  ({
    selected,
    singleColumn,
    children,
  }: {
    selected: boolean;
    singleColumn: boolean;
    children: ReactNode;
  }): ReactElement => (
    <div
      className={classNames(
        { selected, 'single-column': singleColumn },
        'login-signup-tab-pane'
      )}
    >
      {children}
    </div>
  )
);
